import {
  createReducer,
  createRequestReducer,
  formatDate
} from 'utils';

import { GET_POST } from './constants';

const initialState = {
  result: null,
  isFetching: false,
  fetchingErrors: null
};

export default createReducer(initialState, {
  [GET_POST]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state) =>
        Object.assign(state, initialState),

      SUCCESS: (state, action) => {
        const post = action.request.response;

        const result = Object.assign({}, post, {
          dateDisplay: formatDate(post.datePublished)
        });

        return Object.assign(state, {
          result,
          isFetching: false
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/Post/reducer.js